export const isDevEnv = process.env.NODE_ENV === 'development';
export const isHomologEnv = window.location.href.indexOf('lkp.dev.br') > -1;
export const isProductionEnv = process.env.NODE_ENV === 'production';
